import moment from "moment";
import { RELATIVE_RANGE_TYPES, RELATIVE_ALL_TIME } from "views/Constants";
import { isTypeRelativeWithStartOnly } from "views/typeGuards/timeRange";
const DEFAULT_CLASSIFIED_RANGE = {
  value: 5,
  unit: "minutes",
  isAllTime: false
};
export const RELATIVE_CLASSIFIED_ALL_TIME_RANGE = {
  value: 0,
  unit: "seconds",
  isAllTime: true
};
export const classifyRange = (range, allTimeValue) => {
  if (range === null) {
    return DEFAULT_CLASSIFIED_RANGE;
  }
  if (range === allTimeValue) {
    return RELATIVE_CLASSIFIED_ALL_TIME_RANGE;
  }
  return RELATIVE_RANGE_TYPES.map(({ type }) => {
    const diff = moment.duration(range, "seconds").as(type);
    if (diff - Math.floor(diff) === 0) {
      return {
        value: diff || 0,
        unit: type,
        isAllTime: false
      };
    }
    return null;
  }).filter(Boolean).pop();
};
export const classifyFromRange = (range) => classifyRange(range, RELATIVE_ALL_TIME);
export const classifyToRange = (range) => classifyRange(range, void 0);
export const classifyRelativeTimeRange = (timeRange) => {
  if (isTypeRelativeWithStartOnly(timeRange)) {
    return {
      type: "relative",
      from: classifyFromRange(timeRange.range),
      to: classifyToRange(void 0)
    };
  }
  return {
    type: "relative",
    from: classifyFromRange(timeRange.from),
    to: classifyToRange(timeRange.to)
  };
};
export const isTypeRelativeClassified = (timeRange) => timeRange && "type" in timeRange && timeRange.type === "relative" && "from" in timeRange && typeof (timeRange == null ? void 0 : timeRange.from) === "object" && "to" in timeRange && typeof timeRange.to === "object";
export const normalizeClassifiedRange = ({ value, unit, isAllTime }) => {
  if (isAllTime) {
    return RELATIVE_ALL_TIME;
  }
  return moment.duration(value || 1, unit).asSeconds();
};
export const normalizeIfClassifiedRelativeTimeRange = (timeRange) => {
  if (isTypeRelativeClassified(timeRange)) {
    const fromRange = timeRange.from.value !== null ? normalizeClassifiedRange(timeRange.from) : null;
    const toRange = timeRange.to.value !== null ? normalizeClassifiedRange(timeRange.to) : null;
    if (timeRange.to.isAllTime) {
      return {
        type: "relative",
        from: fromRange
      };
    }
    return {
      type: "relative",
      from: fromRange,
      to: toRange
    };
  }
  return timeRange;
};
